import content from "./content";
import { useEffect, useRef, useState } from 'react';
import { Icon } from './UI';

// Obfuscation only: decoded after an explicit click, never during initial rendering.
// This deters simple scrapers; it is not encryption or a barrier to browser bots.
const encodedAddress = content.site.email.value;
export default function ProtectedEmail({
  showIcon = true
}) {
  const [address, setAddress] = useState('');
  const link = useRef(null);
  useEffect(() => {
    if (address) link.current?.focus();
  }, [address]);
  return <span className="protected-email">
    {address ? <a ref={link} href={'mailto:' + address}>{showIcon && <Icon name="mail" />}{address}</a> : <button type="button" onClick={() => setAddress(encodedAddress.map(value => String.fromCharCode(value ^ content.site.email.key)).join(''))}>
          {showIcon && <Icon name="mail" />}{content.site.email.revealLabel}</button>}
  </span>;
}
